import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';
import { DrugQstChoice } from '../drug-qst-choice/DrugQstChoice';

/**
 * # DrugQuestion
 *
 * 복용약 문진
 */
export const DrugQuestion = types
  .model('DrugQuestion')
  // --------------------------------------------------------------------------
  .props({
    drugQstSid: types.maybeNull(types.number),
    drugQst: types.maybeNull(types.string),
    drugQstTypeCd: types.maybeNull(CommonCd),
    order: types.maybeNull(types.number),
    subjectiveYn: types.maybeNull(types.string),
    multiSelectYn: types.maybeNull(types.string),
    langCd: types.maybeNull(types.string),
    drugQstChoiceList: types.maybeNull(types.array(DrugQstChoice)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model drugQuestion --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: Partial<IDrugQuestionSnapshot>) => {
      const newProps = { ...self, ...props } as IDrugQuestion;
      (Object.keys(newProps) as TDrugQuestionKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDrugQuestion = Instance<typeof DrugQuestion>;
type TDrugQuestionSnapshot = SnapshotOut<typeof DrugQuestion>;

export interface IDrugQuestion extends TDrugQuestion {}
export type TDrugQuestionKeys = keyof TDrugQuestionSnapshot & string;
export interface IDrugQuestionSnapshot extends TDrugQuestionSnapshot {}
export const createDrugQuestion = () => types.optional(DrugQuestion, {} as TDrugQuestion);
